import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const SettingsOutlinedSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18">
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="m3.1 9 2.28-5h7.24l2.28 5-2.28 5H5.38L3.1 9Zm1.63-6h8.54L16 9l-2.73 6H4.73L2 9l2.73-6Zm5.77 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm1 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
        />
    </svg>
)

const SettingsOutlinedIcon: React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>{SettingsOutlinedSvg}</SvgIcon>

export default SettingsOutlinedIcon
